import { mapCubeToProject } from '@dc-shared-web/lib/cubeMappers'
import { useAxiosContext } from '@dc-shared-web/providers'
import { useQuery, UseQueryOptions } from 'react-query'
import { Project } from '@dc-shared-web/hooks/api/project/types'
import { fetchProjects } from '@dc-shared-web/hooks'
import { sortObjectsNumerically } from '@dc-shared-web/hooks/utils/sortFunctions'

export const useProjects = ({
  params,
  options,
}: {
  params: {
    currentTeamUuid: string
    currentTable: string
    page: 'folder' | 'dashboard'
    folderId?: number
  }
  options?: Omit<UseQueryOptions<Project[], Error>, 'queryKey' | 'queryFn'>
}) => {
  const apiClient = useAxiosContext()
  const nonEmptyParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => Boolean(value))
  )
  return useQuery<Project[], Error>(
    ['projects', 'list', nonEmptyParams],
    async () => {
      const projects = await fetchProjects(apiClient, params)

      return projects
        .sort(sortObjectsNumerically('Project.name'))
        .map(mapCubeToProject)
    },
    options
  )
}
